export default {
    setPatient: (state, patient) => { state.patient = patient },
    setPatientsAndOwners: (state, patientsAndOwners) => { state.patientsAndOwners = patientsAndOwners },
    setOwner: (state, owner) => { state.owner = owner },
}